module.exports = __webpack_public_path__ + "_assets/img/service-b.2dbbcca8.svg";